import React from 'react';
import { Card } from 'antd';
import JiraChannelNotification2 from '../channel_notification';
class IssueModal extends React.Component {
  state = { visible: false };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = (e) => {
    // console.log(e);
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    // console.log(e);
    this.setState({
      visible: false,
    });
  };

  render() {
    let title;
    // if (this.props.issueId) {
    if (this.props.configureId) {
      title = 'Edit a new subscription';
    } else {
      title = 'Create a new subscription';
    }

    return (
      <Card
        // title="Create a new subscription"
        title={title}
      >
        <JiraChannelNotification2
          projectId={this.props.projectId}
          projectName={this.props.projectName}
          channelId={this.props.channelId}
          channel_name={this.props.channel_name}
          channel_type={this.props.channel_type}
          skill={this.props.skill}
          setOption={this.props.setOption}
          closeModal={this.props.closeModal}
          configureId={this.props.configureId}
          isGridSharedChannel={this.props.isGridSharedChannel}
        />
      </Card>
    );
  }
}

export default IssueModal;
